import { HIDROTEST_UYARI_KALIPLARI } from "./hidrotest.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). */
export const PWHT_BELGE_TURU = "pwht";
/** Okunan Documents türü (GELEN_TURLERI anahtarı, "PWHT chart"). */
export const PWHT_GELEN_TURU = "pwht";
export const pwhtGelenTuruMu = (t) => t === PWHT_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = pwht_kaydi.id). */
export const PWHT_OLAY_NESNESI = "pwht_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const PWHT_GIRDI_AILESI = "PWHT-chart-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const PWHT_EXCEL_ADI = "PWHT chart";
/** Bir dosyada en çok grafik (`Chart`). */
export const PWHT_GRAFIK_EN_COK = 4;
/** Bir grafikte en çok kanal (`Channel`). */
export const PWHT_KANAL_EN_COK = 12;
/** Okuma işi kodu ("PWHT-5C11A0E2"); "PW-" uyarı kodlarından ayrı. */
export const pwhtKodu = (kayitId) => `PWHT-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/**
 * Grafik düzeyi alanlar (ROWS, `Channel` boş; sabit sıra; sözleşme §6.3, sürüm 1). Her alanın tüketicisi sözleşmede yazılıdır. `etiket` hem ekran metni
 * hem ROWS'taki Field adıdır (S2). "Chart page" token harcamaz (ön geçişte tanınan sayfanın no'su).
 */
export const PWHT_GRAFIK_ALANLARI = [
    { alan: "sayfa", etiket: "Chart page", kimlik: false }, { alan: "tarih", etiket: "Chart date", kimlik: false },
    { alan: "sure", etiket: "Hold time", kimlik: false }, { alan: "yazili", etiket: "Written temperature and time", kimlik: false },
    { alan: "cihaz_no", etiket: "Recorder number", kimlik: true },
];
/** Kanal düzeyi alanlar (ROWS, `Channel` 1…n; sabit sıra; sözleşme §6.3, sürüm 1). Kişilerin adı, imzası ve kimlik no'su alınmaz. */
export const PWHT_KANAL_ALANLARI = [
    { alan: "riser_no", etiket: "Riser number", kimlik: true }, { alan: "hat_sn", etiket: "Line serial number", kimlik: true },
    { alan: "kaynak", etiket: "Weld", kimlik: false },
];
/** Alanın ekran adı (iki listede aranır); bilinmiyorsa alanın kendisi. */
export const pwhtEtiketi = (alan) => [...PWHT_GRAFIK_ALANLARI, ...PWHT_KANAL_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır). */
export const PWHT_SATIR_BASLIKLARI = ["Chart", "Channel", "Field", "Value", "As written", "Page", "Certainty"];
/* ---------------- değer biçimleri (G9; yalnız kesin değerler karşılaştırılır) ---------------- */
/** Bekleme süresi saat olarak ("2", "2.0", "2,5", "2 h", "2 hrs", "2 sa"); 0 < x ≤ 48 değilse ya da biçim dışıysa null. */
export function saatOku(v) {
    const s = (v ?? "").trim();
    if (!/^\d+(?:[.,]\d+)?\s*(?:h|hrs?|hours?|sa)?$/i.test(s))
        return null;
    const n = Number(/^\d+(?:[.,]\d+)?/.exec(s)[0].replace(",", "."));
    return Number.isFinite(n) && n > 0 && n <= 48 ? n : null;
}
/** Kaynak no ("W3", "w 3", "3") → 1…999; değilse null. */
export function kaynakNo(v) {
    const m = /^W?\s*(\d{1,3})$/i.exec((v ?? "").trim());
    if (!m)
        return null;
    const n = Number(m[1]);
    return n >= 1 && n <= 999 ? n : null;
}
/** "yes" → true, "no" → false (büyük-küçük harf duyarsız); değilse null. */
export function evetHayir(v) {
    const s = (v ?? "").trim().toLowerCase();
    return s === "yes" ? true : s === "no" ? false : null;
}
/* ---------------- uyarılar (G19) ---------------- */
/** Üretilen kodlar (üretim sırası). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). GEN-02 ve GEN-14 yoktur (G40, K28). */
export const PWHT_UYARI_KODLARI = ["KIM-02", "KIM-07", "KIM-08", "PW-01", "PW-05", "PW-02", "PW-03", "PW-04", "GEN-09"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). KIM kalıpları hidrotestinkiyle aynı nesnelerdir. */
export const PWHT_UYARI_KALIPLARI = {
    "KIM-02": HIDROTEST_UYARI_KALIPLARI["KIM-02"], "KIM-07": HIDROTEST_UYARI_KALIPLARI["KIM-07"], "KIM-08": HIDROTEST_UYARI_KALIPLARI["KIM-08"],
    "PW-01": "PWHT chart does not list this weld: {0}.",
    "PW-05": {
        toplam: "Second PWHT chart for {0}: total {1} h, WPS maximum {2} h.",
        sade: "Second PWHT chart for {0}; the total time could not be compared with the WPS.",
    },
    "PW-02": "Shared PWHT chart: also evidence for {0}.",
    "PW-03": "PWHT recorder not in Registers.",
    "PW-04": "Temperature and time read from the trace only (approximate).",
    "GEN-09": "Several documents in one file. Check the page ranges.",
};
//# sourceMappingURL=pwht-grafigi.js.map